import { render, staticRenderFns } from "./HomeClassic.vue?vue&type=template&id=bb620e86&scoped=true"
import script from "./HomeClassic.vue?vue&type=script&lang=js"
export * from "./HomeClassic.vue?vue&type=script&lang=js"
import style0 from "./HomeClassic.vue?vue&type=style&index=0&id=bb620e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../pws_portal/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb620e86",
  null
  
)

export default component.exports